<template>
  <div class="app-container">
    <AppHeader />

    <main class="main-content">
      <router-view v-slot="{ Component, route }">
        <transition :name="route.meta.transition">
          <component :is="Component" />
        </transition>
      </router-view>
    </main>
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from './components/layout/AppHeader.vue';
import AppFooter from './components/layout/AppFooter.vue';

export default {
  components: {
    AppHeader,
    AppFooter,
  },
  mounted() {
    document.dispatchEvent(new Event('render-event'));
  },
};
</script>

<style>
h2 {
  font-family: 'Oswald', sans-serif;
  font-weight: 700;
  text-transform: uppercase;
  text-shadow: 2px 2px 5px rgba(36, 36, 36, 0.8);
}

body,
p,
a,
li,
button {
  font-family: 'Lato', sans-serif;
  font-weight: 400;
}

body {
  background: #000000;
  background: radial-gradient(
    circle,
    rgba(0, 0, 0, 1) 0%,
    rgba(9, 11, 26, 1) 82%
  );

  color: #eee;
  margin: 0;
  text-align: center;
}

h1 {
  font-size: 3rem;
  color: #c0392b;
  margin: 1rem 0 0.5rem;
}

p {
  font-size: 1.2rem;
  max-width: 600px;
  margin: 0 auto 2rem;
}

.app-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.main-content {
  flex: 1 1 auto;
}

/* Transition CSS */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: opacity 0.5s ease, transform 0.5s ease;
}
.fade-slide-enter-from {
  opacity: 0;
  transform: translateY(20px);
}
.fade-slide-enter-to {
  opacity: 1;
  transform: translateY(0);
}
.fade-slide-leave-from {
  opacity: 1;
  transform: translateY(0);
}
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(20px);
}

.load-hidden {
  visibility: hidden;
}
</style>
